import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiCalendarModule } from '@components/ui-calendar/ui-calendar.module';
import { UiDeploymentSettingsComponent } from '@components/ui-forms/deployment/ui-deployment-settings.component';
import { UiNugetDeploymentSettingsComponent } from '@components/ui-forms/deployment/ui-nuget-deployment-settings.component';
import { UiFoldersDefaultRolesModule } from '@components/ui-forms/general/ui-folders-default-roles';
import { UiGeneralSettingsComponent } from '@components/ui-forms/general/ui-general-settings.component';
import { UiMailSettingsComponent } from '@components/ui-forms/mail/ui-mail-settings.component';
import { UiScalabilityComponent } from '@components/ui-forms/scalability/ui-scalability-settings.component';
import { UiSecuritySettingsComponent } from '@components/ui-forms/security/ui-security-settings.component';
import { UiSkippedDaysCalendarItemComponent } from '@components/ui-forms/skipped-days/calendar-item/calendar-item.component';
import { UiSkippedDaysSettingsComponent } from '@components/ui-forms/skipped-days/ui-skipped-days-settings.component';
import { UiPasswordIndicatorModule } from '@components/ui-password-indicator/ui-password-indicator.module';
import { UiPasswordTypeToggleModule } from '@components/ui-password-toggle/ui-password-toggle.module';
import { MatTooltipModule } from '@directives/ui-tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiClipboardModule } from '@uipath/angular/directives/ui-clipboard';
import { UiDragAndDropModule } from '@uipath/angular/directives/ui-drag-and-drop-file';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

const SETTING_FORMS = [
    UiSecuritySettingsComponent,
    UiGeneralSettingsComponent,
    UiDeploymentSettingsComponent,
    UiScalabilityComponent,
    UiNugetDeploymentSettingsComponent,
    UiMailSettingsComponent,
    UiSkippedDaysSettingsComponent,
];

@NgModule({
    imports: [
        CommonModule,
        ComponentSharedModule,
        TranslateModule,
        MatCheckboxModule,
        MatInputModule,
        MatIconModule,
        MatCardModule,
        MatTooltipModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        UiCalendarModule,
        UiSuggestModule,
        MatListModule,
        MatChipsModule,
        MatDividerModule,
        UiPasswordTypeToggleModule,
        UiPasswordIndicatorModule,
        MatRadioModule,
        UiNgLetModule,
        UiAutofocusModule,
        UiClipboardModule,
        UiDragAndDropModule,
        UiFoldersDefaultRolesModule,
        UiSpinnerButtonModule,
    ],
    declarations: [
        ...SETTING_FORMS,
        UiSkippedDaysCalendarItemComponent,
    ],
    exports: [
        ...SETTING_FORMS,
    ],
})
export class UiSettingFormModule { }
